import { get, post } from "../util/axiosConfig";
//获取报告
export const getModuleReport = params => get("/express/report/getModuleReport", params)
//获取验证码
export const getCaptcha = params => get("/user/getCaptcha", params)
//获取默认省市
export const checkCaptcha = params => get("/user/checkCaptcha", params)
//获取省市列表
export const cityList = params => get("/express/cityList", params)
//获取公校列表
export const schoolList = params => get("/express/schoolList", params)
//注册到账号中心
export const register = params => post("/user/register", params)
//落地页注册
export const registerLP = params => post("/user/registerLP", params)
//注册
export const registerLPNew = params => post("/user/registerLPNew", params)
//获取默认省市
export const getSpm = params => get("/express/getSpm", params)
//点击去体验发送事件到 CRM
export const crmEvent = params => get("/user/crmEvent", params)
